import {IdlocaGeneric} from "../locales/IdlocaGeneric";

export enum GarageType {
    Service = "Service",
    Store = "Store",
    Rent = "Rent",
    School = "School",
    ServiceStore = "Service,Store"
}

interface IGarageTypeConfig {
    name: GarageType;
    locaId: IdlocaGeneric;
}

export const garageConfig: IGarageTypeConfig[] = [
    {name: GarageType.Service, locaId: IdlocaGeneric.service},
    {name: GarageType.Store, locaId: IdlocaGeneric.store},
    {name: GarageType.Rent, locaId: IdlocaGeneric.rent},
    {name: GarageType.School, locaId: IdlocaGeneric.school},
];

